import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';
import { LogoStyles } from '@hrworks/sui-core/Logo';

import { S as SqwLayoutStyles } from '../SqwLayout.styles';

type ContainerProps = {
  isSidebarCollapsed: boolean;
};

const Container = styled.div<ContainerProps>(({ theme, isSidebarCollapsed }) => {
  const { header, sidebar } = SqwLayoutStyles.componentConfig(theme);

  return {
    display: 'flex',
    height: header.height,
    paddingInline: sidebar.horizontalPadding,
    alignItems: 'center',
    width: sidebar.width,
    flexShrink: 0,
    position: 'relative',
    '::before': {
      content: '""',
      position: 'absolute',
      left: isSidebarCollapsed ? -sidebar.width : 0,
      width: sidebar.width,
      height: '100%',
      backgroundColor: theme.eclipseTier2Color.background.nav.default,
      zIndex: -1,
      boxShadow: `1px 0 0 0 ${isSidebarCollapsed ? 'transparent' : theme.eclipseTier2Color.border.nav.subtle}`,
    },

    [mq.conditionalTransition]: {
      '::before': {
        transition: `left ${theme.variables.animationDuration.long}, box-shadow ${theme.variables.animationDuration.long}`,
      },
    },

    [mq.isSmallDevice]: {
      maxWidth: sidebar.width,
      width: 'auto',
      '::before': {
        left: 0,
        boxShadow: 'none',
      },
    },
  };
});

const ToggleWrapper = styled.div(({ theme }) => ({
  [mq.isLargeDevice]: {
    flex: 1,
  },
  display: 'flex',
  paddingRight: theme.eclipseTier1.spacing['12px'],
}));

const LogoWrapper = styled.div(({ theme }) => ({
  height: '100%',
  overflow: 'hidden',
  paddingBlock: theme.eclipseTier1.spacing['12px'],
  [LogoStyles.sel.Logo]: {
    maxWidth: SqwLayoutStyles.componentConfig(theme).header.logoWidth,
  },
}));

const Spacer = styled.div({
  flex: 1,
});

export const S = {
  Container,
  ToggleWrapper,
  LogoWrapper,
  Spacer,
} as const;
